import formatDate from './format-date.js'

// formatDateUnix expects input to be a UnixNano timestamp
export default function formatDateNano(timestampNano, format, options) {
    if (!timestampNano) {
        return '-'
    }
    return formatDate(new Date(Math.round(timestampNano / 1000000)), format, options)
}
